{
  "eyebrow": "Facturatie & betaling",
  "title": "Bijna klaar.",
  "sub": "Ga naar onze beveiligde checkout om je 30-daagse proefperiode te starten. Je wordt vandaag niet afgerekend.",
  "summary": {
    "company": "Bedrijf",
    "plan": "Abonnement",
    "cycle": "Facturatiecyclus",
    "users": "Gebruikers",
    "vtt": "Vehicle Track & Trace",
    "vehicles": "Voertuigen",
    "total": "Geschat totaal / maand",
    "vttOn": "Inbegrepen"
  },
  "secureNote": "Beveiligde checkout via Stripe · 30 dagen gratis proefperiode · Stop wanneer je wil",
  "continue": "Doorgaan naar Stripe",
  "submitting": "Stripe wordt geopend…",
  "canceled": {
    "title": "Betaling geannuleerd",
    "sub": "Er is niets afgerekend. Probeer opnieuw of neem contact op als je hulp nodig hebt.",
    "retry": "Probeer opnieuw"
  },
  "promo": {
    "toggle": "Heb je een promocode?",
    "placeholder": "Promocode",
    "apply": "Toepassen",
    "chip": "{{percent}}% korting",
    "remove": "Promocode verwijderen",
    "errorGeneric": "De code kon niet worden gecontroleerd. Probeer opnieuw."
  },
  "errors": {
    "generic": "Kan checkout niet starten. Probeer opnieuw."
  },
  "totalUnavailable": "Prijscatalogus niet beschikbaar. Probeer opnieuw om de laatste prijzen te laden."
}
